import { ORDER_MANAGER_API_URL } from '@hcs/urls';

export const ADMIN_QC_WS_BASE_URL = `${
  window.location.protocol === 'http:' ? 'ws:' : 'wss:'
}//${ORDER_MANAGER_API_URL.split('://', 2)[1]}/ws?token=`;
